import { AUTH, ROLES, USERS } from "../../api/endpoints";
import { baseApi } from "./baseApi";

const multipart =
  typeof FormData !== "undefined"
    ? { headers: { "Content-Type": "multipart/form-data" } }
    : {};

/**
 * Auth HTTP endpoints. Session orchestration (credentials, permissions merge,
 * impersonation localStorage) stays in authSlice — it dispatches these under the hood.
 */
export const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    login: build.mutation({
      query: (credentials) => ({
        url: AUTH.LOGIN,
        method: "POST",
        data: credentials,
      }),
    }),
    logout: build.mutation({
      query: () => ({ url: AUTH.LOGOUT, method: "POST" }),
    }),
    getProfile: build.query({
      query: () => ({ url: AUTH.PROFILE, method: "GET" }),
      providesTags: [{ type: "Auth", id: "PROFILE" }],
    }),
    updateProfile: build.mutation({
      query: (formData) => ({
        url: AUTH.PROFILE_UPDATE,
        method: "POST",
        data: formData,
        ...multipart,
      }),
      invalidatesTags: [{ type: "Auth", id: "PROFILE" }],
    }),
    forgotPassword: build.mutation({
      query: (payload) => ({
        url: AUTH.FORGOT_PASSWORD,
        method: "POST",
        data: payload,
      }),
    }),
    resetPassword: build.mutation({
      query: (payload) => ({
        url: AUTH.RESET_PASSWORD,
        method: "POST",
        data: payload,
      }),
    }),
    changePassword: build.mutation({
      query: (payload) => ({
        url: AUTH.CHANGE_PASSWORD,
        method: "POST",
        data: payload,
      }),
    }),
    savePlayerId: build.mutation({
      query: (formData) => ({
        url: AUTH.SAVE_PLAYER_ID,
        method: "POST",
        data: formData,
        ...multipart,
      }),
    }),
    getAuthMeetings: build.query({
      query: (params = {}) => ({
        url: AUTH.MEETINGS,
        method: "GET",
        params,
      }),
      providesTags: [{ type: "Meeting", id: "AUTH" }],
    }),
    getRoleByIdForAuth: build.query({
      query: (roleId) => ({ url: ROLES.BY_ID(roleId), method: "GET" }),
    }),
    impersonateUser: build.mutation({
      query: (userId) => ({
        url: USERS.IMPERSONATE(userId),
        method: "POST",
      }),
      invalidatesTags: [{ type: "Auth", id: "PROFILE" }],
    }),
    leaveImpersonation: build.mutation({
      query: () => ({
        url: USERS.IMPERSONATE_LEAVE,
        method: "POST",
      }),
      invalidatesTags: [{ type: "Auth", id: "PROFILE" }],
    }),
  }),
});

export const {
  useLoginMutation,
  useLogoutMutation,
  useGetProfileQuery,
  useLazyGetProfileQuery,
  useUpdateProfileMutation,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useChangePasswordMutation,
  useSavePlayerIdMutation,
  useGetAuthMeetingsQuery,
  useLazyGetAuthMeetingsQuery,
  useLazyGetRoleByIdForAuthQuery,
  useImpersonateUserMutation,
  useLeaveImpersonationMutation,
} = authApi;
